import React from 'react';
import {Outlet} from "react-router-dom";
import Header from './Header';
import Siders from './Siders';
import {Layout} from "antd";
import SessionTimeoutManager from '../../Common/SessionTimeoutManager';
const {Content} = Layout;

function MainAdminLayout() {
	return (
		<div>
			<Layout className='commonAdminlayout'>
				<SessionTimeoutManager userType="admin" />
				<Siders/>
				<Layout>
					<Header/>
					<Content className='contentOverflow'><Outlet/></Content>
				</Layout>
			</Layout>
		</div>
	)
}

export default MainAdminLayout
